<template>
  <div class="modal-fullscreen">
    <section class="layout-flex-col">
      <section class="text-lg flex justify-between">
        <span class="text-base">
          <transition name="fade-in">
            <svg
              v-if="showPrevButton"
              @click="prev"
              name="arrow-left"
              class="font-bold cursor-pointer"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M0.366228 10.9883C-0.122076 10.4417 -0.122076 9.55396 0.366228 9.00734L5.36647 3.40996C5.85478 2.86335 6.64779 2.86335 7.13609 3.40996C7.6244 3.95658 7.6244 4.84429 7.13609 5.39091L4.26876 8.60066H18.7499C19.4414 8.60066 20 9.22599 20 10C20 10.774 19.4414 11.3993 18.7499 11.3993H4.26876L7.13609 14.6091C7.6244 15.1557 7.6244 16.0434 7.13609 16.59C6.64779 17.1367 5.85478 17.1367 5.36647 16.59L0.366228 10.9927V10.9883Z" fill="#282E3E" />
            </svg>
          </transition>
        </span>
        <span class="cursor-pointer underline skipped text-sm" @click="skip">{{ $i18nPresenter.t('Skip') }}</span>
      </section>
    </section>

    <transition name="slide-right">
      <section v-if="showPurposeOptions" class="purpose-options layout-flex-col question-layout">
        <h1 class="question font-bold text-center text-xl px-7">
          {{ $i18nPresenter.t('What do you mainly use AhaSlides for?') }}
        </h1>
        <button
          class="purpose border rounded-lg px-5 py-3 flex justify-between items-center text-base font-bold"
          @click="selectPurpose(purpose)"
          v-for="purpose in purposes"
          :key="purpose.label"
        >
          <h1>{{ $i18nPresenter.t(purpose.label) }}</h1>
          <img :src="purpose.img">
        </button>
      </section>
    </transition>

    <transition name="slide-left">
      <section v-if="showProfessionOptions" class="profession-section layout-flex-col question-layout">
        <h1 class="question font-bold text-center text-xl">
          {{ $i18nPresenter.t('What is your profession?') }}
        </h1>
        <label
          class="profession border rounded pl-3 py-4 flex items-center cursor-pointer"
          v-for="profession in selectedPurpose.professions"
          :value="profession.label"
          :key="profession.label"
        ><aha-radio
          class="mr-1"
          name="profession-select"
          type="radio"
          :value="profession.label"
          v-model="selectedProfession"
        ></aha-radio><span class="label">{{ $i18nPresenter.t(profession.label) }}</span></label>
        <aha-button
          size="xl"
          class="submit"
          v-if="finalStep"
          @click="saveInfo"
          :disabled="!selectedProfession"
        >
          {{ $i18nPresenter.t('Continue') }}
        </aha-button>
      </section>
    </transition>
  </div>
</template>
<script>
// TODO
// Check the displayed scenario in Home page
// style radio button (black)
// style the arrow (follow the design)
import { mapState, mapActions } from 'vuex'
import * as Sentry from '@sentry/vue'
import Utils from '@/util'
import mixpanelUtils from '@/utils/mixpanel.utils'
import eventCategories from '@/constant/eventCategories'
import { MAX_STEP } from '@/constant/UserScreening.constants'
import { getPurposes } from '@/utils/on-board'

const PURPOSES = getPurposes()
export default {
  data() {
    return {
      step: 1,
      selectedPurpose: null,
      selectedProfession: '',
    }
  },
  computed: {
    ...mapState({
      currentUser: (state) => state.currentUser,
    }),
    purposes() {
      return PURPOSES
    },
    finalStep() {
      return MAX_STEP
    },
    showPrevButton() {
      return this.step > 1
    },
    showProfessionOptions() {
      return !!this.selectedPurpose && this.step === this.finalStep
    },
    showPurposeOptions() {
      return this.step === 1
    },
  },
  watch: {
    selectedProfession() {
      Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'New user screening > Step 2 > Select an option', this.selectedProfession)
    },
    selectedPurpose() {
      Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'New user screening > Step 1 > Select an option', this.selectedPurpose.label)
    },
    step(val) {
      if (val === 1) {
        Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'New user screening > Step 1')
      }

      if (val === 2) {
        Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'New user screening > Step 2')
      }
    },
  },
  mounted() {
    // Fire when Modal render
    Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'New user screening > Step 1')
  },
  methods: {
    ...mapActions([
      'patchCurrentUserAction',
    ]),
    selectPurpose(option) {
      this.selectedProfession = ''
      this.selectedPurpose = option
      this.patchUserScreening(this.selectedPurpose.label, null)
      this.next()
    },
    next() {
      this.step++
    },
    prev() {
      Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'New user screening > Back')
      this.step--
    },
    async skip() {
      const mpLabel = this.step === 1 ? 'Step 1' : 'Step 2'
      Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'New user screening > Skip', mpLabel)
      this.$emit('skip')

      try {
        await this.patchCurrentUserAction({
          userId: this.currentUser.id,
          personalInformation: {
            skipUserScreening: true,
          },
        })
      } catch (error) {
        Sentry.captureException(error)
      }
    },
    async saveInfo() {
      const userScreening = {
        useAhaSlidesFor: this.selectedPurpose.label,
        userProfession: this.selectedProfession,
      }
      mixpanelUtils.register({
        ...userScreening,
      })
      Utils.mixpanelTracking(eventCategories.PRESENTATION_LIST, 'New user screening > Done')
      this.$emit('done')
      this.patchUserScreening(userScreening.useAhaSlidesFor, userScreening.userProfession)
    },
    async patchUserScreening(purpose, profession) {
      try {
        await this.patchCurrentUserAction({
          userId: this.currentUser.id,
          personalInformation: {
            useAhaSlidesFor: purpose,
            userProfession: profession,
          },
        })
      } catch (error) {
        Sentry.captureException(error)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
$breakpoint-desktop: 1200px;
$user-screening-bg: #F0F4FA;
$header-height: 60px;

.modal-fullscreen {
  position: absolute;
  inset: 0;
  background-color: $user-screening-bg;
  inset: $header-height 0 0 0;
}

.skipped {
  color: #999999;
  font-weight: 100;
}

.fade-in-enter-active, .fade-in-leave-active {
  transition: opacity 200ms, width 400ms;
}

.fade-in-enter, .fade-in-leave-to {
  opacity: 0;
  width: 0;
}

.slide-right-enter-active, .slide-right-leave-active {
  transition: opacity 300ms, transform 300ms;
}

.slide-right-enter, .slide-right-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.slide-left-enter-active, .slide-left-leave-active {
  transition: opacity 300ms, transform 300ms;
}

.slide-left-enter, .slide-left-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.question-layout {
  position: absolute;
  inset: 40px 0 0 0;
}

.layout-flex-col {
    --content-width: 375px;
    --padding-inline-size: 1rem;
    --padding-block-size: 1rem;
    --gap-size: 0.75rem;
    --bg-color: $user-screening-bg;
    --option-bg: white;
    --border-color: #D3D7E1;

    background-color: var(--bg-color);
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    flex-direction: column;
    padding-block: var(--padding-block-size);
    gap: var(--gap-size);

    & > * {
        inline-size: min(100% - (var(--padding-inline-size)*2), var(--content-width));
        //debug
        // outline: 1px dashed red;
        &.question {
          margin-block-end: 0.25rem;
        }

        &.purpose {
          border-color: var(--border-color);
          background-color: var(--option-bg);
        }

        &.profession {
          border-color: var(--border-color);
          background-color: var(--option-bg);

          &:has(input[type=radio]:checked) {
            background-color: #ECF4FE;
            border-color: #348ef6;
          }

          & .label {
            line-height: initial;
          }
        }

        &.submit {
          margin-block-start: 0.25rem;
        }
    }

    /* This is how to custom
    &.custom {
        --content-width: var(--size-sm);
    } */
}
</style>
